import { CompanyUser } from '@/api';
import { useMyCompanyUsers, useNullableCompanyContext } from '../providers';

/**
 * My own company user in the *selected* company, or null when no company is
 * selected. Callers fail closed on null.
 */
export function useMyCompanyUser(): CompanyUser | null {
    const { company } = useNullableCompanyContext();

    return useMyCompanyUserFor(company?.id ?? '');
}

/**
 * My own company user in a specific company, for screens scoped to a company
 * other than the selected one — the standalone device page, which a QR code can
 * open for any company the user belongs to, is why this exists.
 */
export function useMyCompanyUserFor(companyId: string): CompanyUser | null {
    const { myUsersByCompanyId } = useMyCompanyUsers();

    return myUsersByCompanyId.get(companyId) ?? null;
}
